import { Outlet } from 'react-router-dom'

/**
 * 鉴权布局: 全屏居中, 用于登录与角色选择
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-dvh items-center justify-center p-4 sm:p-6">
      <Outlet />
    </div>
  )
}
